import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import LanguageSwitcher from './LanguageSwitcher';

const Navbar: React.FC = () => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();
  const { t } = useTranslation();
  
  // Hide navbar on landing page
  if (location.pathname === '/') {
    return null;
  }

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-brand">
          {t('branding.appName')}
        </Link>
        
        <div className="navbar-nav">
          <LanguageSwitcher />
          {isAuthenticated ? (
            <div className="user-menu">
              <span className="user-name">{t('dashboard.welcome')}, {user?.full_name}</span>
              <Link to="/dashboard" className="nav-link">{t('navigation.dashboard')}</Link>
            </div>
          ) : (
            <div className="auth-menu">
              <Link to="/login" className="nav-link">{t('navigation.login')}</Link>
              <Link to="/register" className="nav-link">{t('navigation.register')}</Link>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 